import React from 'react';
import './Tour.css';
import image1 from '../../images/tour image/tour-img4.jpg'

const Tour = () => {
    return (
        <div id="tour">
            <h2 className="text-center my-5 fs-1 font-bold">Popular Tour Details</h2>
            
        <div className="tour-detail-container">
            <div>
            <div className="tour-detail">
                <div><h1>Super Maldives Trip</h1></div>
                <div><p className="fs-4 font-bold"><span className="span">$ 560</span> / Per Person</p></div>
            </div>
                <div className="detail-img">
                    <img src={image1} alt="" />
                </div>
                <p>Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo.</p>
            </div>
            <div className="detail-booking">
                <h1>Book This Tour</h1>
                <input className="mb-3 p-2" type="text" name="" id="" placeholder="Your Name" /><br />
                <input className="mb-3 p-2" type="text" name="email" id="" placeholder="Email Address" /><br />
                <input className="mb-3 p-2" type="text" name="" id="" placeholder="Phone Number" /><br />
                <input className="mb-3 p-2" type="text" data-select="datepicker" name="reservation_date" id="" placeholder="Departure Date" /><br />
                <input className="mb-3 p-2" type="text" name="" id="" placeholder="Number of Person" />
                <button className="bookNowBtn">Book Now</button>
            </div>
        </div>
        </div>
    );
};

export default Tour;